// TODO: adding all app pages to this config (centralized & avoid mistyping)
const appPages = {
  welcome: "welcome",
  homePage: "home_page",
  timerElementsPage: "timer_elements_page",

  scheduleCall: "appointment",

  integrations: "integrations",
  integrationsV2: "integrations",
  integrationsDesktopSync: "integrations_windows",
  integrationsCalendar: "integrations_calendar",
  integrationsOutlook: "integrations_outlook",
  integrationsHealth: "integrations_health",
  integrationsChrome: "integrations_chrome",
  integrationsSlack: "integrations_slack",
  integrationsOnboarding: "integrations_onboarding",

  integrationsMappingGame: "integrations_mapping_game",
  integrationsMappingDone: "integrations_mapping_done",
  integrationsMappingPage: "integrations_mapping_page",
  integrationsDeletePage: "integrations_delete_page",
  integrationsIgnorePage: "integrations_ignore_page",
  integrationRulesPage: "integrations_rules_page",
  integrationsHistoryPage: "integrations_history_page",

  trackHome: "track",
  trackDetail: "journal_detail",

  elementsPage: "elements_v2",
  editElement: "edit_element",
  archiveElementsPage: "archive_elements",

  customizeElementsPage: "customize-elements",

  routinesPage: "routines",

  resolutionPage: "goals",
  resolutionEditPage: "resolution_detail",

  reportsPage: "reports",
  viewReport: "view_report",
  sentReports: "sent_reports",
  receivedReports: "team",
  receivedAggregatedReports: "received_aggregated_reports",
  reportComments: "discussion",

  pendingLogin: "pending_login",

  reflectionPage: "reflect",
  reflectionDetailPage: "gem",
  sets_reflection: "sets_reflection",
  comparisonPage: "reflection-comparison",

  enabledUsers: "enabled_users",

  terms: "terms",
  onboardingPage: "onboarding",
  onboardingInfoPage: "onboarding_info",
  onboardingAnimPage: "onboarding_img",

  payments: "pay",

  testingPage: "testing",

  scheduleTimePage: "schedule_time",

  coachingRoom: "coaching_room",
};

export default appPages;
